import { render, staticRenderFns } from "./RuleModal.vue?vue&type=template&id=7b540f83&"
import script from "./RuleModal.vue?vue&type=script&lang=js&"
export * from "./RuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b540f83')) {
      api.createRecord('7b540f83', component.options)
    } else {
      api.reload('7b540f83', component.options)
    }
    module.hot.accept("./RuleModal.vue?vue&type=template&id=7b540f83&", function () {
      api.rerender('7b540f83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/RuleModal.vue"
export default component.exports